import {
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Input,
  Spinner,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/tabs";
import React, { useEffect, useRef, useState } from "react";
import { useTabs } from "@chakra-ui/tabs";
import { useDispatch, useSelector } from "react-redux";
import {
  BASE_URL_EVENT,
  BASE_URL_MEDIA,
  getEventDetails,
} from "../Redux/App/action";
import { IoIosAddCircle } from "react-icons/io";
import TopSlider from "../Components/Home/TopSlider";
import axios from "axios";
import { BsCardImage, BsFillCalendarDateFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import venueimg from "../assets/venuedefaultimg.png";

const Events = () => {
  const accessToken = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(0);
  const { allEvents } = useSelector((store) => store.appReducer);
  const { tabs, selectedPanelIndex } = useTabs({ selectedIndex: activeTab });
  const [eventName, seteventName] = useState("");
  const [eventType, seteventType] = useState("");
  const [venue, setvenue] = useState("");
  const [eventDetails, seteventDetails] = useState("");
  const [eventTiming, seteventTiming] = useState("");
  const [expectedNoOfGuests, setexpectedNoOfGuests] = useState("");
  const [venuePinCode, setvenuePinCode] = useState("");
  const imageRef = useRef(null);
  const calender = useRef(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [imageId, setImageId] = useState("");
  const today = new Date();
  const maxDate = new Date();
  const [eventId, setEventId] = useState("");

  maxDate.setFullYear(today.getFullYear() + 5);
  useEffect(() => {
    dispatch(getEventDetails);
  }, [dispatch]);

  const handleClickImage = () => {
    imageRef.current.click();
  };
  const handleFileChange = (e) => {
    const files = e.target.files;

    if (files.length > 10) {
      setErrorMessage("You can only upload a maximum of 10 images.");
      e.target.value = ""; // Clear the selected files
    } else {
      setErrorMessage("");
      setSelectedImages(Array.from(files));
      // Handle the selected files here
    }
  };

  const handleImage = () => {
    const formData = new FormData();
    formData.append("productFiles", ...selectedImages);
    axios
      .post(
        `${BASE_URL_MEDIA}/media/file/admin/upload/productfiles?imageGroup=PRODUCT`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: "123456",
          },
        },
      )
      .then((response) => {
        setImageId(response.data);
      })
      .catch((error) => {
        console.log(`${error.message}`);
      });
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("eventName", eventName);
    formData.append("eventType", eventType);
    formData.append("venue", venue);
    formData.append("eventDetails", eventDetails);
    formData.append("eventTiming", eventTiming);
    formData.append("expectedNoOfGuests", expectedNoOfGuests);
    formData.append("venuePincode", venuePinCode);
    formData.append("venueImg", imageId);
    axios
      .post(`${BASE_URL_EVENT}/create`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(`${error.message}`);
      });
  };

  useEffect(() => {
    setActiveTab(1);
  }, []);

  const currentDate = new Date();

  // Filter events into past and upcoming
  const pastEvents = allEvents.filter((event) => {
    const eventDate = new Date(event.eventTiming);
    return eventDate < currentDate;
  });

  const upcomingEvents = allEvents.filter((event) => {
    const eventDate = new Date(event.eventTiming);
    return eventDate >= currentDate;
  });

  const eventIdLocal = () => {
    localStorage.setItem(eventId);
  };

  return (
    <>
      <Box>
        <TopSlider />
      </Box>
      <h1
        className="text-3xl font-bold flex justify-start pl-10 pt-4  sm:pt-10 fontfamily-oswald my-2 page-heading"
        style={{ fontFamily: "Oswald, sans-serif" }}
      >
        My Events
      </h1>
      <Tabs p={1} {...tabs}>
        <TabList mb="1em" bgColor={"#F5F5F5"}>
          <Tab
            w={"50%"}
            borderRadius={10}
            justifyContent={"center"}
            fontWeight={"bold"}
            fontSize={18}
            className="oswald-font"
          >
            My Event
          </Tab>
          <Tab w={"50%"} borderRadius={10}>
            {" "}
            <Flex
              alignItems={"center"}
              gap={{ md: 20, base: 0 }}
              justifyContent={"center"}
              fontWeight={"bold"}
              fontSize={{ md: 18, base: 17 }}
              className="oswald-font"
            >
              <IoIosAddCircle size={20} color="green" /> Create Event
            </Flex>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Box>
              {/* Upcoming Events */}
              <Box>
                {upcomingEvents.length > 0 ? (
                  <>
                    <Text
                      fontSize="xl"
                      fontWeight="bold"
                      mb={"10"}
                      className={"oswald-font"}
                    >
                      Upcoming Events
                    </Text>
                    <Box
                      display="grid"
                      gridTemplateColumns={{
                        md: "repeat(2, 1fr)",
                        base: "repeat(1, 1fr)",
                      }}
                      gap={{ md: 4, base: 2 }}
                      overflowX="auto"
                    >
                      {upcomingEvents.map((el, i) => (
                        <Box key={i}>
                          <Flex
                            borderRadius={10}
                            gap={2}
                            textAlign={"left"}
                            boxShadow={
                              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;"
                            }
                            px={1}
                            overflowY={"auto"}
                            flexDirection={{ md: "row", base: "column" }}
                          >
                            <Image
                              src={el.venueImgUrl ? el.venueImgUrl : venueimg}
                              w={{ md: "20%", base: "10%" }}
                              borderRadius={10}
                              h={{ md: 20, base: "20%" }}
                              m={{ md: 0, base: "auto" }}
                            />
                            <Box
                              w={{ md: "40%", base: "90%" }}
                              px={{ md: 5, base: 0 }}
                              py={{ md: 2, base: 0 }}
                              m={{ md: 0, base: "auto" }}
                            >
                              <Text
                                fontWeight={"bold"}
                                fontSize={{ md: 14, base: 12 }}
                              >
                                {el.eventName}
                              </Text>
                              <Text
                                h={{ md: 10, base: 6 }}
                                overflowX={"auto"}
                                fontWeight={"semibold"}
                                fontSize={{ md: 14, base: 12 }}
                              >
                                {el.eventDetails}
                              </Text>
                            </Box>
                            <Flex
                              flexDirection={{ md: "column", base: "row" }}
                              gap={{ md: 0, base: 10 }}
                              w={{ md: "40%", base: "90%" }}
                              px={{ md: 5, base: 0 }}
                              py={{ md: 2, base: 0 }}
                              m={{ md: 0, base: "auto" }}
                            >
                              <Text
                                fontWeight={"semibold"}
                                fontSize={{ md: 14, base: 12 }}
                              >
                                {el.expectedNoOfGuests} Guests
                              </Text>
                              <Text fontWeight={"semibold"} fontSize={14}>
                                {el.venue},
                                <br />
                                {el.venuePincode}
                              </Text>
                            </Flex>
                            <Flex
                              w={{ md: "40%", base: "90%" }}
                              px={{ md: 5, base: 0 }}
                              py={{ md: 2, base: 0 }}
                              m={{ md: 0, base: "auto" }}
                              alignItems={"center"}
                              flexDirection={{ md: "column", base: "row" }}
                              gap={{ md: 0, base: 10 }}
                              // justifyContent={{md:"left"}}
                            >
                              <Text
                                fontWeight={"semibold"}
                                fontSize={{ md: 14, base: 12 }}
                              >
                                {el.eventTiming && el.eventTiming.split("T")[0]}
                              </Text>
                              <Text
                                fontWeight={"semibold"}
                                fontSize={14}
                                mt={{ md: 2, base: 0 }}
                              >
                                {el.eventTiming && el.eventTiming.split("T")[1]}
                              </Text>

                              <Link to={"/InvitationSubCat"}>
                                <Button
                                  h={6}
                                  colorScheme="red"
                                  onClick={() => {
                                    localStorage.setItem("eventId", el.id);
                                  }}
                                >
                                  Add Invitation
                                </Button>
                              </Link>
                            </Flex>
                          </Flex>
                        </Box>
                      ))}
                    </Box>
                  </>
                ) : (
                  <Text
                    fontSize="xl"
                    fontWeight="bold"
                    className={"oswald-font"}
                  >
                    No Upcoming Events
                  </Text>
                )}
              </Box>

              <Divider
                orientation="horizontal"
                border="2px solid gray"
                h={0.1}
                mr="10"
                mt="5"
              />
              {/* Past Events */}
              <Box>
                {pastEvents.length > 0 ? (
                  <>
                    <Text
                      fontSize="xl"
                      fontWeight="bold"
                      className={"oswald-font"}
                    >
                      Past Events
                    </Text>
                    <Box
                      display="grid"
                      gridTemplateColumns={{
                        md: "repeat(2, 1fr)",
                        base: "repeat(1, 1fr)",
                      }}
                      gap={{ md: 4, base: 2 }}
                      overflowX="auto"
                    >
                      {pastEvents.map((el, i) => (
                        <Box key={i}>
                          <Flex
                            borderRadius={10}
                            gap={2}
                            textAlign={"left"}
                            boxShadow={
                              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;"
                            }
                            px={1}
                            overflowY={"auto"}
                            flexDirection={{ md: "row", base: "column" }}
                          >
                            <Image
                              src={el.venueImgUrl}
                              w={{ md: "20%", base: "40%" }}
                              borderRadius={10}
                              h={{ md: 20, base: 40 }}
                              m={{ md: 0, base: "auto" }}
                            />
                            <Box
                              w={{ md: "40%", base: "90%" }}
                              px={{ md: 5, base: 0 }}
                              py={{ md: 2, base: 0 }}
                              m={{ md: 0, base: "auto" }}
                            >
                              <Text
                                fontWeight={"bold"}
                                fontSize={{ md: 14, base: 12 }}
                              >
                                {el.eventName}
                              </Text>
                              <Text
                                h={{ md: 10, base: 6 }}
                                overflowX={"auto"}
                                fontWeight={"semibold"}
                                fontSize={{ md: 14, base: 12 }}
                              >
                                {el.eventDetails}
                              </Text>
                            </Box>
                            <Flex
                              flexDirection={{ md: "column", base: "row" }}
                              gap={{ md: 0, base: 10 }}
                              w={{ md: "40%", base: "90%" }}
                              px={{ md: 5, base: 0 }}
                              py={{ md: 2, base: 0 }}
                              m={{ md: 0, base: "auto" }}
                            >
                              <Text
                                fontWeight={"semibold"}
                                fontSize={{ md: 14, base: 12 }}
                              >
                                {el.expectedNoOfGuests} Guests
                              </Text>
                              <Text fontWeight={"semibold"} fontSize={14}>
                                {el.venue},
                                <br />
                                {el.venuePincode}
                              </Text>
                            </Flex>
                            <Flex
                              w={{ md: "40%", base: "90%" }}
                              px={{ md: 5, base: 0 }}
                              py={{ md: 2, base: 0 }}
                              m={{ md: 0, base: "auto" }}
                              alignItems={"center"}
                              flexDirection={{ md: "column", base: "row" }}
                              gap={{ md: 0, base: 10 }}
                              // justifyContent={{md:"left"}}
                            >
                              <Text
                                fontWeight={"semibold"}
                                fontSize={{ md: 14, base: 12 }}
                              >
                                {el.eventTiming && el.eventTiming.split("T")[0]}
                              </Text>
                              <Text
                                fontWeight={"semibold"}
                                fontSize={14}
                                mt={{ md: 2, base: 0 }}
                              >
                                {el.eventTiming && el.eventTiming.split("T")[1]}
                              </Text>

                              <Link to={"/allinvitaions"}>
                                <Button h={6} colorScheme="red">
                                  Add Invitation
                                </Button>
                              </Link>
                            </Flex>
                          </Flex>
                        </Box>
                      ))}
                    </Box>
                  </>
                ) : (
                  <Box h={"50vh"} p={"10"}>
                    <Text
                      fontSize="xl"
                      fontWeight="bold"
                      className={"oswald-font"}
                    >
                      Past Events
                    </Text>
                    <Text fontSize="sm" className={"oswald-font"} mt={"10"}>
                      No Past Events
                    </Text>
                  </Box>
                )}
              </Box>
            </Box>
          </TabPanel>
          <TabPanel>
            <Flex
              alignItems={"center"}
              textAlign={"left"}
              flexDirection={{ md: "row", base: "column" }}
            >
              <Box w={{ md: "50%", base: "100%" }}>
                <Flex alignItems={"center"} gap={5}>
                  <Text
                    color={"#AFAFAF"}
                    w={"30%"}
                    fontWeight={"semibold"}
                    fontSize={{ md: 14, base: 12 }}
                  >
                    Event Name
                  </Text>
                  <Input
                    type="text"
                    border={0}
                    h={7}
                    borderBottom={"2px solid #AFAFAF"}
                    borderRadius={0}
                    w={"50%"}
                    value={eventName}
                    fontSize={{ md: 14, base: 12 }}
                    focusBorderColor="transparent"
                    _focusVisible={false}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(
                        /[^a-zA-Z\s]/g,
                        "",
                      );
                      seteventName(sanitizedValue);
                    }}
                  />
                </Flex>
                <Flex alignItems={"center"} gap={5} mt={3}>
                  <Text
                    color={"#AFAFAF"}
                    w={"30%"}
                    fontWeight={"semibold"}
                    fontSize={{ md: 14, base: 12 }}
                  >
                    Event Type
                  </Text>
                  <Input
                    type="text"
                    border={0}
                    h={7}
                    borderBottom={"2px solid #AFAFAF"}
                    borderRadius={0}
                    w={"50%"}
                    fontSize={{ md: 14, base: 12 }}
                    focusBorderColor="transparent"
                    _focusVisible={false}
                    value={eventType}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(
                        /[^a-zA-Z\s]/g,
                        "",
                      );
                      seteventType(sanitizedValue);
                    }}
                  />
                </Flex>
                <Flex alignItems={"center"} gap={5} mt={3}>
                  <Text
                    color={"#AFAFAF"}
                    w={"30%"}
                    fontWeight={"semibold"}
                    fontSize={{ md: 14, base: 12 }}
                  >
                    Event Details
                  </Text>
                  <Input
                    type="text"
                    border={0}
                    h={7}
                    borderBottom={"2px solid #AFAFAF"}
                    borderRadius={0}
                    w={"50%"}
                    fontSize={{ md: 14, base: 12 }}
                    focusBorderColor="transparent"
                    _focusVisible={false}
                    value={eventDetails}
                    onChange={(e) => {
                      const sanitizedValue = e.target.value.replace(
                        /[^a-zA-Z\s]/g,
                        "",
                      );
                      seteventDetails(sanitizedValue);
                    }}
                  />
                </Flex>
                <Flex alignItems={"center"} gap={5} mt={3}>
                  <Text
                    color={"#AFAFAF"}
                    w={"30%"}
                    fontWeight={"semibold"}
                    fontSize={{ md: 14, base: 12 }}
                  >
                    Event Timing
                  </Text>
                  <Input
                    type="datetime-local"
                    border={0}
                    h={7}
                    borderBottom={"2px solid #AFAFAF"}
                    borderRadius={0}
                    w={"50%"}
                    fontSize={{ md: 14, base: 12 }}
                    focusBorderColor="transparent"
                    _focusVisible={false}
                    value={eventTiming}
                    min={today.toISOString().slice(0, 16)} // Set minimum date to current date
                    max={maxDate.toISOString().slice(0, 16)}
                    onChange={(e) => seteventTiming(e.target.value)}
                  />
                </Flex>
              </Box>
              <Box w={{ md: "50%", base: "100%" }} mt={5}>
                <Flex alignItems={"center"} gap={5}>
                  <Text
                    color={"#AFAFAF"}
                    w={"30%"}
                    fontWeight={"semibold"}
                    fontSize={{ md: 14, base: 12 }}
                  >
                    Venue
                  </Text>
                  <Input
                    type="text"
                    border={0}
                    h={7}
                    borderBottom={"2px solid #AFAFAF"}
                    borderRadius={0}
                    w={"50%"}
                    fontSize={{ md: 14, base: 12 }}
                    focusBorderColor="transparent"
                    _focusVisible={false}
                    value={venue}
                    onChange={(e) => {
                      setvenue(e.target.value);
                    }}
                  />
                </Flex>
                <Flex alignItems={"center"} gap={5} mt={3}>
                  <Text
                    color={"#AFAFAF"}
                    w={"30%"}
                    fontWeight={"semibold"}
                    fontSize={{ md: 14, base: 12 }}
                  >
                    Venue Pin Code.
                  </Text>
                  <Input
                    type="number"
                    border={0}
                    h={7}
                    borderBottom={"2px solid #AFAFAF"}
                    borderRadius={0}
                    w={"50%"}
                    value={venuePinCode}
                    fontSize={{ md: 14, base: 12 }}
                    focusBorderColor="transparent"
                    _focusVisible={false}
                    onChange={(e) => setvenuePinCode(e.target.value)}
                  />
                </Flex>
                <Flex alignItems={"center"} gap={5} mt={3}>
                  <Text
                    color={"#AFAFAF"}
                    w={"30%"}
                    fontWeight={"semibold"}
                    fontSize={{ md: 14, base: 12 }}
                  >
                    Expected No. Of Guests
                  </Text>
                  <Input
                    type="number"
                    border={0}
                    h={7}
                    borderBottom={"2px solid #AFAFAF"}
                    borderRadius={0}
                    w={"50%"}
                    value={expectedNoOfGuests}
                    fontSize={{ md: 14, base: 12 }}
                    focusBorderColor="transparent"
                    _focusVisible={false}
                    onChange={(e) => setexpectedNoOfGuests(e.target.value)}
                  />
                </Flex>
                <Flex
                  alignItems={"center"}
                  gap={5}
                  mt={3}
                  flexDirection={{ md: "row", base: "column" }}
                >
                  <Text
                    color={"#AFAFAF"}
                    w={{ md: "40%", base: "100%" }}
                    fontWeight={"semibold"}
                    fontSize={{ md: 14, base: 12 }}
                  >
                    Attach Venue Image
                  </Text>
                  <Flex>
                    <Input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleFileChange}
                      w={"40%"}
                      ref={imageRef}
                      h={8}
                      display={"none"}
                    />
                    <Button onClick={handleClickImage}>Choose</Button>
                    <Button
                      onClick={handleImage}
                      bg={"transparent"}
                      color={"red"}
                      cursor={"pointer"}
                    >
                      save
                    </Button>
                  </Flex>
                </Flex>
                <Box></Box>
              </Box>
            </Flex>

            <Button
              isDisabled={!imageId}
              borderRadius={10}
              bg={"#FC1A64"}
              color={"white"}
              fontWeight={"bold"}
              mt={10}
              w={{ md: "20%", base: "40%" }}
              onClick={handleSubmit}
            >
              CREATE
            </Button>

            <Flex gap={4} mt="2" overflowY={"auto"} pb="2">
              {selectedImages.map((file, index) => (
                <Image
                  src={URL.createObjectURL(file)}
                  alt={`Selected Image ${index}`}
                  key={index}
                  w="20%"
                  h="150"
                />
              ))}
            </Flex>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  );
};

export default Events;
